import { WidgetType } from 'types/widget.types';

import { DEFAULT_BG, DEFAULT_FG, DEFAULT_SIZE_HEIGHT_PX, DEFAULT_SIZE_WIDTH_PX } from './LottieWidget.config';
import { VERSION } from './LottieWidget.upgrade';

/**
 * Generate default Lottie widget data
 *
 * @param url - Lottie URL
 * @param topPxOverride - top position override
 * @param leftPxOverride - left position override
 * @returns {Object} default Lottie widget data
 */
const generateLottieDefaultData = (url: string, topPxOverride?: number, leftPxOverride?: number) => {
  const widget = {
    widgetType: WidgetType.Lottie,
    widgetData: {
      version: VERSION,
      topPx: topPxOverride || 0,
      leftPx: leftPxOverride || 0,
      rotateDeg: 0,
      url,
      widthPx: DEFAULT_SIZE_WIDTH_PX,
      heightPx: DEFAULT_SIZE_HEIGHT_PX,
      foreGroundColor: DEFAULT_FG,
      backgroundColor: DEFAULT_BG,
      altText: `Animation`,
      isDecorative: false,
    },
  };

  return widget;
};

export { generateLottieDefaultData };
